// Import dependencies
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { capaCreate } from '../../../actions/capa';

// Import CSS & assets
import './NewCapa.css';

const NewCapa = ({ user, capacityFullList, setCapacityFullList, setCapacityFilteredList, setToasterMessage }) => {

    // Set global functions
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Hooks
    const [isGroupDetailed, setIsGroupDetailed] = useState(false);
    const [groupName, setGroupName] = useState("Nouveau groupe");
    const [groupType, setGroupType] = useState("batch");
    const [isLoading, setIsLoading] = useState(false);
    const [isCreating, setIsCreating] = useState(false);

    // Set specific functions
    // Create new capa
    const createNewCapa = () => {
        setIsCreating(true);
        // Check new capa is allowed
        var new_capa_allowed = false;
        var isLastAllowed = false;
        if (!(user?.teams[0]?.plan?.limitations?.nb_capa_max)) {
            console.log("No limitations");
            new_capa_allowed = true;
        }
        else if (capacityFullList.length < user?.teams[0]?.plan?.limitations?.nb_capa_max) {
            console.log("Limitations not reached, ", user?.teams[0]?.plan?.limitations?.nb_capa_max - capacityFullList.length, " available");
            new_capa_allowed = true;
            if (user?.teams[0]?.plan?.limitations?.nb_capa_max - capacityFullList.length === 1) {
                isLastAllowed = true;
            }
        }
        else {
            console.log("Limitations reached");
            setToasterMessage("Quota atteint", "Obtenez un compte Premium pour continuer à créer des études capacitaires.\nContactez notre équipe à hello@proplab.fr.");
            setIsCreating(false);
        }

        // If allowed, create new capa
        if (new_capa_allowed) {
            var userId = "";
            var teams = [];
            var info = {
                user_name: "",
                team_name: "",
                group_type: null,
                isLastAllowed: isLastAllowed,
            };
            if (user?.result?._id) { userId = user.result._id; info.user_name = (user?.result?.firstName || "") + " " + (user?.result?.lastName || "") };
            if (user?.teams && user.teams.length > 0) { teams = [user.teams[0]._id]; info.team_name = user.teams[0]?.name || "" };
            const formData = { userId, teams, info };
            // setTimeout(() => {
            //     console.log("CREATION");
            //     setIsCreating(false);
            // }, 2000);
            dispatch(capaCreate(formData, handleSuccess, handleFail));
        }
    }

    // Group
    const openGroupDetails = () => {
        setIsGroupDetailed(true);
    }
    const closeGroupDetails = () => {
        if (!isLoading) {
            setIsGroupDetailed(false);
            setTimeout(() => {
                setGroupName("Nouveau groupe");
                setGroupType("batch");
                document.getElementById("newcapa_group_title").value = "Nouveau groupe";
                document.getElementById("newcapa_group_type").value = "batch";
                // setIsLoading(false);
            }, 600);
        }
    }
    const handleGroupName = (value) => {
        setGroupName(value);
    }
    const handleGroupType = (value) => {
        setGroupType(value);
    }
    const createNewGroup = () => {
        setIsLoading(true);
        var userId = "";
        var teams = [];
        var info = {
            user_name: "",
            team_name: "",
            group_title: groupName || "Nouveau groupe",
            group_type: groupType, // "batch" or "variant"
        };
        if (user?.result?._id) { userId = user.result._id; info.user_name = (user?.result?.firstName || "") + " " + (user?.result?.lastName || "") };
        if (user?.teams && user.teams.length > 0) { teams = [user.teams[0]._id]; info.team_name = user.teams[0]?.name || "" };
        const formData = { userId, teams, info };
        console.log("CREATE GROUP", formData);
        dispatch(capaCreate(formData, handleSuccessGroup, handleFail));
        // setTimeout(() => {
        //     handleSuccessGroup();
        // }, 1000);
    }
    // Loading
    const handleSuccess = (data) => {
        console.log("SUCCESS", data);
        navigate(`/capastudy/${data.result._id}`);
    }
    const handleSuccessGroup = (data) => {
        console.log("SUCCESS GROUP", data);
        setIsLoading(false);
        closeGroupDetails();
        // Update list
        var newCapaList = [data.result].concat(capacityFullList);
        console.log('CAPA LIST', newCapaList);
        setCapacityFullList(newCapaList);
        setCapacityFilteredList(newCapaList);
        // navigate(`/capastudy/${data.result._id}`);
    }
    const handleFail = (error) => {
        console.log("FAIL", error.response.data.message);
        setToasterMessage("Erreur", "Une erreur est survenue.\n\nSi cela persiste, contactez notre équipe à hello@proplab.fr.");
        setIsCreating(false);
    }

    return (
        <div id="dashboard_new_capa" className="app__newcapa_container">
            <div className={`app__newcapa_container_content ${isGroupDetailed ? "app__newcapa_container_content_flipped" : ""}`}>
                <div className="app__newcapa_container_subcontent app__newcapa_container_subcontent_front">
                    <div className="app__newcapa_subcontainer">
                        <button className={`app__newcapa_button ${isCreating ? "app__newcapa_button_loading" : ""}`} onClick={createNewCapa}>+</button>
                        <div className="app__newcapa_text">{isCreating ? "Création ..." : "Nouvelle étude"}</div>
                    </div>
                    {/* <div className="app__newcapa_subcontainer_separator"></div>
                    <div className="app__newcapa_subcontainer">
                        <button className="app__newcapa_button_small" onClick={openGroupDetails}>+</button>
                        <div className="app__newcapa_text_small">Nouveau groupe d'études</div>
                    </div> */}
                </div>
                <div className="app__newcapa_container_subcontent app__newcapa_container_subcontent_back" onMouseLeave={closeGroupDetails}>
                    <div className="app__newcapa_subcontainer">
                        <div className="app__newcapa_text_title">Créer un groupe d'études</div>
                    </div>
                    <div className="app__newcapa_subcontainer_items">
                        {/* <div className="app__newcapa_text_xsmall">Nom du groupe</div> */}
                        <div className="app__rulecatalog_filter_container">
                            <div className="common__input_container">
                                <input type="text" className="app__rulecatalog_filter" placeholder="Nom du groupe" name="newcapa_group_title" id="newcapa_group_title" value={groupName} onChange={(e) => { handleGroupName(e.target.value) }} autoComplete="off"></input>
                                <label htmlFor="newcapa_group_title" className="app__rulecatalog_filter_label">Nom du groupe</label>
                            </div>
                        </div>
                        <div className="app__newcapa_text_xsmall" style={{ marginTop: '16px' }}>Type de groupe</div>
                        <select className="app__newcapa_select" id="newcapa_group_type" onChange={(e) => { handleGroupType(e.target.value) }} defaultValue={groupType}>
                            <option value="batch">Analyse globale</option>
                            <option value="variant">Variantes</option>
                        </select>
                    </div>
                    <div className="app__newcapa_subcontainer_buttons">
                        {isLoading ?
                            <>
                                <div className="app__card_top_validation_text" style={{ color: "grey", maxWidth: "100%", marginBottom: "0px" }}>Création du groupe ...</div>
                            </>
                            :
                            <>
                                <div className="app__card_top_validation_button_green" onClick={createNewGroup}>Créer</div>
                                <div className="app__card_top_validation_button_red" onClick={closeGroupDetails}>Annuler</div>
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewCapa;